import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Famous last words: Pfft, that's easy",
  "description": "",
  "published": "2020-01-10T00:00:00.000Z",
  "redirect_from": ["/blog/famous-last-words-pfft-thats-easy/swizec/9278"],
  "categories": "Opinions, Technical",
  "hero": "./img/techletter.app-screenshot-1578676638985.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "/06a5bc9114b3b51f0ccb0d7f2f5afcf7/nGYgiuF.gif",
        "alt": null
      }}></img>{` Coding isn't always fun my friend, sometimes it's work.`}</p>
    <p>{`Actually, I take that back. `}<em parentName="p">{`Coding`}</em>{` is fun, `}<em parentName="p">{`engineering`}</em>{` is work. Let me explain.`}</p>
    <p>{`2 months ago I got a new project at work. Enable customer support to change people's plans. We sell subscriptions and sometimes folks wanna change the plan they're on.`}</p>
    <p>{`Pfft, that's easy.`}</p>
    <p>{`Stop old subscription, start new subscription, fiddle start dates so it looks like nothing happened. How hard can it be?`}</p>
    <p>{`So I estimate the project line by line.`}</p>
    <p>{`Gonna have to do this, do that, oh and we need a new UI for everything, wait what they wanna change payment methods too?? Oh shit you want to do what with refunds and credits and referral bonuses!?`}</p>
    <p>{`I slog through the combinatorial explosion. Installment plans, plans paid once, referral credits, family discounts ... the mind recoils in horror.`}</p>
    <p>{`16 combinations in all. Maybe more.`}</p>
    <p>{`Estimate came out to 2 weeks. So much for easy. And here we are now 2 months later almost done.`}</p>
    <p>{`More tests than code, 200 comments on pull requests across 4 repositories, 8 bugs from QA, 16 bugs from business, 3 years old production bugs, and I can't even count the issues I found while testing bugs. Last find was that your initial payment on a new plan never got charged. Fix took all day.`}</p>
    <p><img parentName="p" {...{
        "src": "/f99eb5644879615d564c597d6b77056a/media-loNN8YOofuHsc-giphy.gif",
        "alt": null
      }}></img></p>
    <h2 {...{
      "id": "what-the-hell-happened"
    }}>{`What the hell happened??`}</h2>
    <blockquote>
      <p parentName="blockquote">{`when you're going through hell, keep going`}</p>
    </blockquote>
    <p>{`Legacy code and engineering happened my friend.`}</p>
    <p>{`Coding is fun because you're building something from scratch. It's fast, it's free, it's beautiful. Like running in an empty green field.`}</p>
    <p>{`You jump and frolic. You skip and hop. You sing with the sound of joy in your heart as you create something new that's never existed before and you care not if it still works tomorrow.`}</p>
    <p><img parentName="p" {...{
        "src": "/ad37a77872f2d1802849b281f4e857ea/media-30Poyd7yWZTPi-giphy.gif",
        "alt": "sound_of_music giphy"
      }}></img></p>
    <p>{`Engineering ... engineering is more like threading a new subway line through downtown New York.`}</p>
    <p>{`Tall buildings that shouldn't collapse. Traffic that can't be too disrupted. Businesses that definitely have to keep running. Old subway lines you can't destroy. Sewage pipes you shouldn't touch. Internet cables you can't break. Power lines you shouldn't cut.`}</p>
    <p>{`If you're lucky you might find `}<a parentName="p" {...{
        "href": "https://www.schneier.com/blog/archives/2009/06/secret_govermen.html"
      }}>{`dark fibre`}</a>{` and get the secret service on your ass.`}</p>
    <p>{`No wonder it took San Francisco `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Central_Subway"
      }}>{`almost 10 years to add 10 blocks of subway`}</a>{` ...`}</p>
    <p>{`Oh and while you're keeping all that old stuff alive, you're making sure the new stuff not only supports the old stuff, but keeps working for decades to come.`}</p>
    <h2 {...{
      "id": "tips-for-legacy-code"
    }}>{`Tips for legacy code`}</h2>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1215353115504865280"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "86.09865470852019%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'344\\'%20viewBox=\\'0%200%20400%20344\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2020c-3%202-7%206-8%2010-1%203%201%2011%203%2011v1l2%203c2%201%202%201%201-1%200-3%200-3%204-2%204%200%209-2%206-4-1-1%200-1%201-1%204-1%203-1%201%204-3%205-4%206-8%206h-3c2%203%2013%202%2017-1l3-2-4-1c-2%200-3-1-3-2%200-2%204-5%206-4l1-1c0-1%200-2%201-1%202%201%202-3%201-6-3-8-13-12-21-9m5%2085l1%201c1%200%202%201%202%203v2l-4-2-3-3%201%202%203%204%204%201-2%201c-7%202-10%202-9-1l-2-1c-2%200-2%200-1%201l1%203%201%202v3c-2-1-2%200-2%201l1%202c2-1%204%203%203%206l1%201%204%203c3%204%209%207%2033%2019l17%206%202%201%204%204c6%203%206%204%203%207l-2%203v1c-1%201-1%208%201%208l1%203h-1c-2-3-2%200-1%203l1%204v1c0%201-3%203-4%202l-4-15-4%201-4%202c1%202-1%204-3%203-3%200-6%202-6%205l-1%201-3%202c0%203%200%203-2%202-3-2-6%200-9%206-2%205-2%205%200%204%201%200%202%202%200%203l-1%202c1%201%200%202-1%202-3%201-2%2016%203%2023l2%206c-1%201-1%200-2-1%200-2-1-3-4-4l-2-1c0-1-6-8-8-8s-1%201%202%204c4%203%204%204%202%204h-3l-2%201c0%201%204%203%207%203%202%200%202%200%202%202l-1%202-15-3%208-19c2-3%202-4%201-5H29c-4%200-5%201-5%204s0%203%203%203h4c1%201%200%201-2%201-4%200-5%201-5%205%201%202%201%202%206%201l5%201-3%201c-5%200-8%202-8%204%200%203%203%208%205%208a4891%204891%200%2000168-2l-8-3h-4c-3%201-13-5-11-8%201-3%2015%200%2017%203l4%202h6c2%201%204%201%207-1l5-2%203-1%202-1c1%201-2%205-3%204l-4%207%204%201h2c0%202%2014%202%2017%201h2l60%201h59v-3c0-2%200-2-2-2h-3l2-2c1%200%202-1%201-4l1-4v-7l-2%202-2%202-1-3v-4l-2-3c-1-1-1-1%205-1%207%200%208-1%207-7%200-5-2-6-6-4h-9l-3-1c-2%200-2%200-1-3%201-2%201-2-2-4-2-2-2-3-1-5%200-3%200-3%209-3l9%201-9%203c-5%200-6%201-5%205%202%204%203%205%206%205%2011-1%2013%200%2014%203l1%203v1c-1%202%200%205%202%205l2%201h6c1%202%201%202-3%202l-5-1v12l-1%206c-1-1-1%200-1%202%200%201%200%202%201%201%201-4%202-2%202%203%200%204%200%204%203%204l4-2c2-2%202-4%202-69v-68l-3-2-2-2H73l-12%204c-12%203-14%204-12%202l1-2v-2c0-1-12-2-13-1m160%2050h-4l-4%201-1%202-1-1-1-1-1%201c1%203-1%203-2%201s-1-2-1%201c1%202%200%205-1%207-6%2013%201%2028%2014%2030l3%201c-2%201-2%205%200%205v-1l1-2c1-1%201%200%201%201l1%202%201-3c-1-3-1-3%203-3l7-4c2-2%205-3%207-3s2%200%201-2c-1-4%200-12%202-12%201%201%201%200%201-3l-1-2v3l-1%201-1-3c0-4-6-13-8-14l-4-1-11-1m-2%203c-9%202-15%2012-13%2022%203%2014%2022%2018%2031%207%2012-13-1-33-18-29m-156%201v12l1%202%201-3%202-2%201%202c0%204%2010%204%2011%200%200-2%202-2%202%201%200%202%200%202%2011%203l6%202v-1c-9-7-9-7-7-9l1-3c-1-1-3%201-3%203l-2%201-4-1-11-4c-6-3-8-4-9-3m121%205l-11%207-11%206-5-2c-6-2-6-2-3%202%203%205%206%207%208%205%200-1%202%200%203%202l5%203%203%202c1%203%205%206%207%205%204%200%204-2%201-4-4-2-1-9%203-9%202%200%201-1-1-5s-3-7%200-8l4-4h-3m34%2012l1%209%2013-9c0-1-11-9-13-9l-1%209m-170%208v14l1%2013h23l1-4%202-7%204-9%204-7-10-1h-8v13l-1%2013v-26h-8l-8%201m98%202l-4%202c-3%200-5%203-2%203a23%2023%200%20015%201l-1%201v11c0%202%202-1%205-8%201-4%202-7%201-9%200-4-1-4-4-1m-43%2099c-3%203-4%206-2%209%201%202%201%202%202%201h3c2%203%206%202%208-1%201-4%201-7-1-7s-5-1-5-3-2-1-5%201m17%201c-3%203-2%207%201%2010%207%206%2016-4%2010-11-4-3-7-3-11%201m42-2l1%202%201%204c0%204-3%203-4-1%200-4-1-5-2-4-3%201-4%206-3%209%203%204%2011%206%209%201h2c0-2%201-2%202-2%202%201%202-5-1-7-3-3-4-3-5-2m14%200c-3%203-4%206-3%2010%203%205%208%206%2013%201%206-6-3-16-10-11m20%200v3l-1%202-1-2c0-1%200-2-1-1l-1%203v2c-2-2-1%203%201%205%203%202%209%202%2011-1%203-3%203-4-1-6-3-1-4-2-3-3l-1-2h-3m15%201c-4%205-2%2010%203%2012%204%200%205%200%202-3-4-4-4-5-4-7l3-1c2%200%202%200%201%201v3l2-2c1-2%201-2%203%202s3%204%202-1c-1-6-7-8-12-4m21-1l-2%201-1%202c-2%201-2%205%200%208%203%205%2013%201%2013-5%200-4-3-6-4-4-1%203-3%202-3%200%201-3%200-3-3-2m17%200l-1%206c0%207%203%209%208%207%202-1%202-1%202-7l-2-6v2l-1%201h-1l-2%201-2-3c1-1-1-2-1-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4532fe5fdadc19cc8fb5c02c83b3bc0c/ca0a1/techletter.app-screenshot-1578676638985.webp 223w", "/static/4532fe5fdadc19cc8fb5c02c83b3bc0c/75680/techletter.app-screenshot-1578676638985.webp 445w", "/static/4532fe5fdadc19cc8fb5c02c83b3bc0c/0ba47/techletter.app-screenshot-1578676638985.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4532fe5fdadc19cc8fb5c02c83b3bc0c/e92b6/techletter.app-screenshot-1578676638985.png 223w", "/static/4532fe5fdadc19cc8fb5c02c83b3bc0c/e66bf/techletter.app-screenshot-1578676638985.png 445w", "/static/4532fe5fdadc19cc8fb5c02c83b3bc0c/6af66/techletter.app-screenshot-1578676638985.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4532fe5fdadc19cc8fb5c02c83b3bc0c/6af66/techletter.app-screenshot-1578676638985.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Engineers love to hate on legacy code.`}</p>
    <p>{`Look at how shitty it is. Look at how messy. Look how it uses old standards. Look how wrong it looks. What idiot wrote this.`}</p>
    <p>{`But hear this my friend, that legacy code is paying your salary. `}<strong parentName="p">{`Legacy code works`}</strong></p>
    <p>{`That's all you gotta keep in mind. Legacy code is legacy `}<em parentName="p">{`because it works`}</em>{`. Your code either dies a prototype or it becomes legacy.`}</p>
    <p>{`Do you want your code to die? No you do not.`}</p>
    <p>{`So suck it up princess and fix that shit.`}</p>
    <p>{`The code is there because it works. Every nook and cranny is there for a reason. Even if the reason is that you didn't know any better when you wrote it 3 years ago.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1214708511042609152"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "71.30044843049328%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'284\\'%20viewBox=\\'0%200%20400%20284\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M35%2019l-7%204c-3%204-3%204-3%2011l1%207%201%202c0%203%2012%207%2017%205s7-5%204-5c-4%200-5-3-2-5l3-1%203-2c7-6-6-18-17-16m27%20127v7h3c3%200%206-3%205-5v-4c0-3-1-4-4-4h-4v6m103%2088c-3%204-3%208%200%2011%203%202%207%203%205%201l-2-1-1-2c1-2%207-2%208%200s1%202%202%200%200-8-1-8l-3-1c-2-3-5-2-8%200m20-1l-4%207h2c1-2%202%200%200%202s2%205%206%205c7%200%2010-8%204-9l-4-3c-1-1-1-1%202-1h2c-1-1-6-2-8-1m35%201c-3%204-3%209%200%2011s5%202%205%201l-1-2-2-3-1-3%208%207h2c2-2%201-9-2-11-3-3-6-3-9%200m22%200v1c-1%200-2%203-1%205v4c-2%201-1%203%202%203s6-2%206-5l1-2c2%200%200-4-2-6-3-2-6-3-6%200m54-1l-1%203-1%202v-3l-1-1-1%203-1%203c-3%201%202%206%206%207%207%200%2010-6%205-8l-3-4c-1-2-2-4-3-2m-94%202c-3%202-3%207%200%207%201%200%203%201%203%203%202%202%202%202%203%201%200-2%201-2%202-1h3c1-3%201-4-1-5l-3-2-2-2-2-1c0-2-1-3-3%200m73%200c-2%202-2%205-1%208s4%203%204%200v-2l1%202c0%202%203%204%206%203%202-2%201-11-2-12-3-2-7-1-8%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2d8d19864bbcdd5fb62bc4c05a30b29b/ca0a1/techletter.app-screenshot-1578676638673.webp 223w", "/static/2d8d19864bbcdd5fb62bc4c05a30b29b/75680/techletter.app-screenshot-1578676638673.webp 445w", "/static/2d8d19864bbcdd5fb62bc4c05a30b29b/0ba47/techletter.app-screenshot-1578676638673.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2d8d19864bbcdd5fb62bc4c05a30b29b/e92b6/techletter.app-screenshot-1578676638673.png 223w", "/static/2d8d19864bbcdd5fb62bc4c05a30b29b/e66bf/techletter.app-screenshot-1578676638673.png 445w", "/static/2d8d19864bbcdd5fb62bc4c05a30b29b/6af66/techletter.app-screenshot-1578676638673.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2d8d19864bbcdd5fb62bc4c05a30b29b/6af66/techletter.app-screenshot-1578676638673.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`So change your mindset and rejoice!`}</p>
    <p>{`You've got a working piece of code that just needs some love.`}</p>
    <p>{`Whatever happened to make it look this bad – business changing their mind, engineers coming and going, or coding standards changing all around it – `}<strong parentName="p">{`that code works and it pays your bills.`}</strong></p>
    <p>{`Do your best.`}</p>
    <ol>
      <li parentName="ol">{`add some tests`}</li>
      <li parentName="ol">{`update the code style`}</li>
      <li parentName="ol">{`ask business if you really absolutely still need to support that feature they asked for 3 years ago and forgot about`}</li>
      <li parentName="ol">{`remove the dead code`}</li>
      <li parentName="ol">{`consolidate messy chunks into pretty functions`}</li>
      <li parentName="ol">{`extract stuff into classes`}</li>
      <li parentName="ol">{`write some notes`}</li>
      <li parentName="ol">{`add comments`}</li>
      <li parentName="ol">{`add some tests`}</li>
      <li parentName="ol">{`then add some more tests`}</li>
      <li parentName="ol">{`make sure you add tests`}</li>
      <li parentName="ol">{`ask a friend for help`}</li>
      <li parentName="ol">{`write some docs, docs are great`}</li>
      <li parentName="ol">{`talk to stakeholders and `}<em parentName="li">{`understand`}</em>{` the business`}</li>
      <li parentName="ol">{`write it all down`}</li>
      <li parentName="ol">{`refactor with a new approach that consolidates what the business wants now into a clean flow`}</li>
      <li parentName="ol">{`oh and write some tests`}</li>
    </ol>
    <p>{`Most of all, don't stop. You're already in hell, might as well keep going until you reach the edge.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1211710370919763969"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "111.21076233183858%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'446\\'%20viewBox=\\'0%200%20400%20446\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2021c-13%207-9%2026%206%2028%207%200%2015-5%209-6-5-1-3-6%202-6l2-1%202-1%201-2-4-9-3-2c-3-3-10-4-15-1m169%20106v6h3c4%200%207-2%205-5v-4c0-3-1-4-5-4-3%200-3%200-3%207m-66%20259c-7%203-4%2014%204%2014%206%200%209-8%205-13-3-2-5-2-9-1m16%201c-3%203-3%207%200%2010%204%206%2013%203%2013-4s-8-10-13-6m20-1c-4%201-5%2010-1%2013%207%204%2016-4%2011-11-1-2-7-3-10-2m17%201c-3%203-3%207%200%207l2%201h-1l-2%201%201%201h1c0%205%208%203%2011-1%203-8-6-15-12-9m18%200c-6%207%202%2017%2010%2012%203-3%204-11%201-11l-2-1c-1-3-6-2-9%200m21-1l-1%201c-4-2-5%206-2%2010%204%206%2013%202%2013-5%200-4-8-9-10-6m16%200c-2%202-3%206-2%206l1-1%201-2%201%204c0%203-1%204-2%202l-1-1c-2%201%204%206%207%206s7-3%205-4v-1c2%200%202-3%200-4v-2c1-1%201-1-1-2-3-2-6-2-9-1m17%201c-6%206%201%2015%2010%2012l2-3c4-8-5-15-12-9m19%201c-2%203-3%206%200%206l1%202c-1%203%200%204%204%204s7-3%207-7c-1-4-3-5-4-2%200%204-1%203-1-1-1-5-4-5-7-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d34afbafe4672b1b202fade419bba55b/ca0a1/techletter.app-screenshot-1578676638774.webp 223w", "/static/d34afbafe4672b1b202fade419bba55b/75680/techletter.app-screenshot-1578676638774.webp 445w", "/static/d34afbafe4672b1b202fade419bba55b/0ba47/techletter.app-screenshot-1578676638774.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d34afbafe4672b1b202fade419bba55b/e92b6/techletter.app-screenshot-1578676638774.png 223w", "/static/d34afbafe4672b1b202fade419bba55b/e66bf/techletter.app-screenshot-1578676638774.png 445w", "/static/d34afbafe4672b1b202fade419bba55b/6af66/techletter.app-screenshot-1578676638774.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d34afbafe4672b1b202fade419bba55b/6af66/techletter.app-screenshot-1578676638774.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      